import { pushDigitalData } from '@/utils/digitalData';

const useSubscription = () => {
  const addNewUserSubscription = (authToken) => {
    pushDigitalData({
      category: 'Auth',
      name: 'Registered',
      user: {
        subscriptions: [{
          type: 'email',
          isSubscribed: true,
        }],
        authToken,
      },
    });
  };

  const addSubscription = (formType, email) => {
    pushDigitalData({
      category: 'Email',
      name: 'Subscribed',
      user: {
        email,
        subscriptions: [{
          type: 'email',
        }],
      },
      campaign: {
        name: formType,
      },
    });
  };

  return { addNewUserSubscription, addSubscription };
};

export default useSubscription;
